import { VaroCategories } from 'shared/analytics/types/categories';
import { ButtonType } from 'shared/analytics/types/componentTypes';
import { VaroListItemName } from 'shared/analytics/types/listItemNames';
import { VaroPressableName } from 'shared/analytics/types/pressableNames';
import { VaroSubCategoryFor } from 'shared/analytics/types/subCategories';

export const ComponentEventNames = {
  BUTTON_PRESSED: 'Button Pressed',
  LIST_ITEM_PRESSED: 'List Item Pressed',
  SCREEN_VIEWED: 'Screen Viewed',
  COMPONENT_VIEWED: 'Component Viewed',
} as const;

export interface ComponentAnalyticsContext<
  TCategory extends VaroCategories = VaroCategories,
> {
  category: TCategory;
  sub_category?: VaroSubCategoryFor<TCategory>;
}

export interface ButtonPressedProperties<
  TCategory extends VaroCategories = VaroCategories,
> extends ComponentAnalyticsContext<TCategory> {
  pressable_name: VaroPressableName;
  component_type: ButtonType;
}

export interface ListItemPressedProperties<
  TCategory extends VaroCategories = VaroCategories,
> extends ComponentAnalyticsContext<TCategory> {
  item_name: VaroListItemName;
  /** Zero-based index of the item within its list. */
  item_position?: number;
}

export interface ScreenViewedProperties<
  TCategory extends VaroCategories = VaroCategories,
> extends ComponentAnalyticsContext<TCategory> {
  screen_name: string;
  screen_url: string;
}

export interface ComponentViewedProperties<
  TCategory extends VaroCategories = VaroCategories,
> extends ComponentAnalyticsContext<TCategory> {
  component_type: string;
  component_name: string;
}

type CategorizedAnalytics = {
  [TCategory in VaroCategories]: {
    category: TCategory;
    subCategory?: VaroSubCategoryFor<TCategory>;
  };
}[VaroCategories];

/** Camel-case counterpart of `ComponentAnalyticsContext`, for component props. */
export type ComponentAnalyticsProps = CategorizedAnalytics;

export type ButtonComponentAnalytics = ComponentAnalyticsProps & {
  pressableName: VaroPressableName;
};

export type ListItemComponentAnalytics = ComponentAnalyticsProps & {
  itemName: VaroListItemName;
  /** Zero-based index within the list. */
  itemPosition?: number;
};
